import {
  flip,
  offset,
  useVirtualFloating,
  UseVirtualFloatingOptions,
} from '@udecode/plate-floating';

import { floatingLinkActions } from './floatingLinksStore';

export const useVirtualFloatingLink = ({
  editorId,
  ...floatingOptions // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
}: { editorId: string } & UseVirtualFloatingOptions) => {
  return useVirtualFloating({
    placement: 'bottom-start',
    onOpenChange: (isOpen) =>
      floatingLinkActions.openEditorId(isOpen ? editorId : null),
    middleware: [
      offset(12),
      flip({
        padding: 96,
      }),
    ],
    ...floatingOptions,
  });
};
